<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="10" offset-md="1">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-card
                          flat>
                          <v-app-bar
                            flat>
                            <v-toolbar-title class="font-weight-bold">
                              Dosen <b>({{ teacherlist.length }})</b>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                              v-if="detaildata[0].s_kelas_tim === '1' ? true : false"
                              color="primary"
                              icon
                              exact
                              @click="inviteDsn(detaildata[0])">
                              <v-icon>mdi-account-plus</v-icon>
                            </v-btn>
                          </v-app-bar>
                          <v-card-text>
                            <v-expansion-panels flat>
                              <v-expansion-panel
                                v-for="(teach, i) in teacherlist"
                                :key="i">
                                <v-expansion-panel-header hide-actions>
                                  <div class="d-flex align-center">
                                    <div class="d-inline">
                                      <v-icon left>mdi-account</v-icon>
                                    </div>
                                    <div class="d-inline">
                                      {{ teach.user_firstname }} {{ teach.user_lastname }}
                                    </div>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <span class="text-right" v-if="false">
                                    <v-menu
                                      offset-y
                                      bottom
                                      left
                                      nudge-bottom="10"
                                      transition="scale-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          color="primary"
                                          class="text-capitalize"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          exact>
                                          <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item>
                                          <v-list-item-title>Remove</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div>
                                    NIP. {{ teach.user_no }}
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card-text>
                        </v-card>
                        <v-card
                          flat>
                          <v-app-bar
                            flat>
                            <v-toolbar-title class="font-weight-bold">
                              Mahasiswa <b>({{ studentlist.length }})</b>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              icon
                              @click="inviteMhs(detaildata[0])">
                              <v-icon>mdi-account-plus</v-icon>
                            </v-btn>
                          </v-app-bar>
                          <v-card-text>
                            <v-expansion-panels flat>
                              <v-expansion-panel
                                v-for="(student, i) in studentlist"
                                :key="i">
                                <v-expansion-panel-header hide-actions>
                                  <div class="d-flex align-center">
                                    <div class="d-inline">
                                      <v-icon left>mdi-account</v-icon>
                                    </div>
                                    <div class="d-inline">
                                      {{ student.user_no }} - {{ student.user_firstname }} {{ student.user_lastname }}
                                    </div>
                                  </div>
                                  <v-spacer></v-spacer>
                                  <span class="text-right">
                                    <v-menu
                                      offset-y
                                      bottom
                                      left
                                      nudge-bottom="10"
                                      transition="scale-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          color="primary"
                                          class="text-capitalize"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          exact>
                                          <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list>
                                        <v-list-item
                                          @click="removeMhs(student)">
                                          <v-list-item-title>Remove</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div>
                                    NIM. {{ student.user_no }}
                                  </div>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'ListclassDosen' }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Daftar kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dmodal.dsn"
      max-width="450px">
      <v-card v-if="dmodaldata.dsn">
        <v-card-title>
          <span>Undang Tim Teaching</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.dsn = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <div class="font-weight-bold">
            Link undangan
            <v-btn
              color="primary"
              icon
              @click="copyInvitelink">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <span class="green--text" v-html="msgcopy"></span>
          </div>
          <div>
            <span>{{ dmodaldata.dsn.inviteurld }}</span>
            <input type="hidden" id="invite-elm" :value="dmodaldata.dsn.inviteurld">
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dmodal.mhs"
      max-width="450px">
      <v-card v-if="dmodaldata.mhs">
        <v-card-title>
          <span>Undang Mahasiswa</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.mhs = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <div class="font-weight-bold">
            Link undangan
            <v-btn
              color="primary"
              icon
              @click="copyInvitelink">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <span class="green--text" v-html="msgcopy"></span>
          </div>
          <div>
            <span>{{ dmodaldata.mhs.inviteurl }}</span>
            <input type="hidden" id="invite-elm" :value="dmodaldata.mhs.inviteurl">
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dmodal.rmhs"
      max-width="450px">
      <v-card v-if="dmodaldata.rmhs">
        <v-card-title>
          <span>Hapus Mahasiswa</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.rmhs = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Hapus mahasiswa dari kelas? <br>
            <b>{{ dmodaldata.rmhs.user_firstname }} {{ dmodaldata.rmhs.user_lastname }}</b>
            <!-- <span class="green--text" v-html="msgcopy"></span> -->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2"
            small
            color="primary"
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemoveMhs(dmodaldata.rmhs)">
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'DetailclasspeopleDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      remove: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    detaildata: [],
    teacherlist: [],
    studentlist: [],
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      rmhs: false,
      mhs: false,
      dsn: false,
    },
    dmodaldata: {
      rmhs: null,
      mhs: null,
      dsn: null,
    },
    msgcopy: '',
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getMemeber();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getMemeber();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    copyInvitelink() {
      this.msgcopy = '';
      const invelm = document.querySelector('#invite-elm');
      invelm.setAttribute('type', 'text');
      invelm.select();
      try {
        document.execCommand('copy');
        this.msgcopy = 'Copied';
      } catch (err) {
        this.msgcopy = 'Unable to copy!';
      }
      invelm.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
      setTimeout(() => this.msgcopy = '', 7000);
    },
    inviteDsn(item) {
      this.dmodal.dsn = true;
      this.msgcopy = '';
      this.dmodaldata.dsn = JSON.parse(JSON.stringify(item));
    },
    confirmRemoveMhs(item) {
      if (this.tokenscr) {
        // console.log(item);
        this.alertupdate.show = false;
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/kelas/student/' + item.id_clastd,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.rmhs = false;
                this.dmodaldata.rmhs = null;
                this.getStudent();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      }
    },
    removeMhs(item) {
      this.dmodal.rmhs = true;
      this.dmodaldata.rmhs = JSON.parse(JSON.stringify(item));
      // console.log(item);
    },
    inviteMhs(item) {
      this.dmodal.mhs = true;
      this.msgcopy = '';
      this.dmodaldata.mhs = JSON.parse(JSON.stringify(item));
    },
    getMemeber() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                const durl = this.$router.resolve({
                  name: 'Invitemahasiswa',
                  params: { class: this.detaildata[0].code_class },
                });
                const durldsn = this.$router.resolve({
                  name: 'Invitedosen',
                  params: { class: this.detaildata[0].code_class },
                });
                const baseurl = window.location.origin;
                this.detaildata[0].inviteurl = baseurl + '' + durl.href + '?class=' + this.detaildata[0].code_class;
                this.detaildata[0].inviteurld = baseurl + '' + durldsn.href + '?class=' + this.detaildata[0].code_class;
                this.getTeacher();
                this.getStudent();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Anggota tidak ditemukan!';
      }
    },
    getTeacher() {
      if (this.tokenscr) {
        this.loading.teacher = true;
        this.axios
          .get(
            this.api + '/api/teacher/kelas/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              this.teacherlist = [];
              // console.log(resdata);
              if (resdata.error === false) {
                this.teacherlist = resdata.data;
              }
            }
            this.loading.teacher = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.teacher = false;
          });
      }
    },
    getStudent() {
      if (this.tokenscr) {
        this.loading.student = true;
        this.axios
          .get(
            this.api + '/api/student/kelas/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              this.studentlist = [];
              // console.log(resdata);
              if (resdata.error === false) {
                this.studentlist = resdata.data;
              }
            }
            this.loading.student = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.student = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
